import { FaUserPlus, FaPlug, FaSliders, FaChartLine } from 'react-icons/fa6'

const steps = [
  {
    num: '01',
    title: 'Daftar & Setup Akun',
    desc: 'Buat akun gratis Anda dalam hitungan menit. Tidak perlu instalasi software — cukup akses melalui browser.',
    icon: FaUserPlus,
  },
  {
    num: '02',
    title: 'Hubungkan Mikrotik',
    desc: 'Masukkan IP dan credential Mikrotik Anda. Sistem akan otomatis mendeteksi dan sinkronisasi dengan konfigurasi existing.',
    icon: FaPlug,
  },
  {
    num: '03',
    title: 'Kelola Pelanggan',
    desc: 'Import data pelanggan, atur paket bandwidth, dan aktifkan auto-billing. Semua terkelola dari satu dashboard.',
    icon: FaSliders,
  },
  {
    num: '04',
    title: 'Monitor & Optimalkan',
    desc: 'Pantau revenue, status jaringan, dan performa bisnis Anda secara real-time dengan laporan yang detail.',
    icon: FaChartLine,
  },
]

export default function LpHowItWorksSection() {
  return (
    <section
      id="cara-kerja"
      className="relative py-24 lg:py-32 grid-bg"
      aria-labelledby="cara-kerja-heading"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <span className="text-ocean-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
            Cara Kerja
          </span>
          <h2
            id="cara-kerja-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6"
          >
            Mulai dalam <span className="gradient-text">4 Langkah Mudah</span>
          </h2>
          <p className="text-slate-custom text-lg leading-relaxed">
            Tidak perlu keahlian teknis khusus. Dalam waktu kurang dari 5 menit,
            sistem Anda sudah siap berjalan.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            {/* Connecting Line */}
            <div
              className="absolute left-6 top-12 bottom-12 w-px bg-gradient-to-b from-ocean-600/40 via-ocean-600/20 to-transparent hidden md:block"
              aria-hidden="true"
            />

            <div className="space-y-8">
              {steps.map((s, i) => {
                const Icon = s.icon
                return (
                  <div
                    key={i}
                    className="reveal flex gap-6 items-start"
                    style={{ transitionDelay: i * 0.15 + 's' }}
                  >
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-ocean-800 to-ocean-600 flex items-center justify-center flex-shrink-0 shadow-lg shadow-ocean-800/30 relative z-10">
                      <span className="font-display font-bold text-white text-sm">
                        {s.num}
                      </span>
                    </div>
                    <div className="card-glow rounded-2xl p-6 flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        <Icon className="text-ocean-500" />
                        <h3 className="font-display font-semibold text-white text-lg">
                          {s.title}
                        </h3>
                      </div>
                      <p className="text-slate-custom leading-relaxed">
                        {s.desc}
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}